import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthShell from './AuthShell';
import Toast from '../../components/forms/Toast';
import Icon from '../../components/common/Icon';
import { apiRequest, handleBranding } from '../../utils';

/* Set-password page reached from the create-team email link. Sets the captain's
   password and creates the team (backend: /api/create-team/set-password). */
const SetTeamPassword = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    handleBranding();
    (async () => {
      try {
        const data = await apiRequest('GET', `/create-team/set-password/${token}`);
        setInfo(data);
      } catch (err) {
        setError(t(err.message, { defaultValue: err.message }));
        setShowToast(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [token, t]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await apiRequest('POST', '/create-team/set-password', { token, password });
      localStorage.setItem('isLoggedIn', '1');
      window.dispatchEvent(new Event('auth-changed'));
      navigate(data.redirect || '/team');
    } catch (err) {
      setError(t(err.message, { defaultValue: err.message }));
      setShowToast(true);
    } finally {
      setSubmitting(false);
    }
  };

  const valid = info && info.valid;

  return (
    <AuthShell
      title={t('setYourPassword')}
      subtitle={valid && info.event_name ? t('creatingTeamFor', { event: info.event_name }) : ''}
    >
      {loading ? (
        <div className="auth__card"><span className="auth__spinner" /></div>
      ) : !valid ? (
        <div className="auth__card"><p>{t('invalidOrExpiredLink')}</p></div>
      ) : (
        <form className="auth__card" onSubmit={submit}>
          <div className="auth__field">
            <label className="auth__label">{t('password')}</label>
            <div className="auth__input-wrap">
              <input className="auth__input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('choosePassword')} autoComplete="new-password" required />
            </div>
            <small style={{ color: '#6b7280', fontSize: '.78rem' }}>{t('passwordHint')}</small>
            <small style={{ display: 'block', color: '#6b7280', fontSize: '.78rem', marginTop: '.35rem' }}>
              {t('savePasswordHint')}
            </small>
          </div>

          <button type="submit" className="auth__primary" disabled={submitting}>
            {submitting ? <span className="auth__spinner" /> : <Icon name="users" />}
            {t('createMyTeamFree')}
          </button>

          <Toast showToast={showToast} setShowToast={setShowToast} message={error} />
        </form>
      )}
    </AuthShell>
  );
};

export default SetTeamPassword;
